import React from "react";

function Modal({ message, onClose }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50">
      <div className="bg-white rounded-xl p-6 sm:p-8 w-11/12 max-w-md text-center shadow-lg">
        <p className="mb-6 text-gray-800">{message}</p>
        <button
          onClick={onClose}
          className="w-52 bg-[#35C3D9] hover:bg-[#27AAC0] text-white text-sm font-semibold rounded-lg py-3 transition-all duration-300 shadow-md hover:shadow-lg"
        >
          OK
        </button>
      </div>
    </div>
  );
}

export default Modal;
